var _circle, _circle2, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "currentColor",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5c.8-1.5 2.2-2.2 3.5-2.2s2.7.7 3.5 2.2",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 11,
    y2: 11,
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedIcon);
export default __webpack_public_path__ + "static/media/unassigned-icon.aaa52955d1a69dc063308aca520b4db6.svg";
export { ForwardRef as ReactComponent };